import React, { Component } from "react";
import { Modal, Table, Input, Button, Tag } from "antd";
import { httpGet, httpUrl } from "../../api/httpClient";
import { numberFormat } from "../../util";
import SelectBox from "../common/SelectBox";
import string from "../../string";

const Search = Input.Search;

class UserList2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      pagination: {
        current: 1,
        total: 0
      },
      searchText: "",
      searchType: "NAME",

      franchise: false,
      selectedStemUser: {}
    };
  }


  searchTypeHandleChange = (value) => {
    // console.log(`checked = ${JSON.stringify(e.target.checked)}`);
    this.setState({
      searchType: value,
      isLoaded: true,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager
    });
    this.getUserStemList({ pageNum: pager.current });
  };

  onSearch = (value) => {
    this.setState(
      {
        searchText: value
      },
      () => {
        this.getUserStemList();
      }
    );
  };

  onOk = () => {
    this.props.onOk(
      this.state.selectedStemUser
    );
    this.props.onCancel();
  };

  onChangeTag = (value) => {
    this.setState({ selectedStemUser: value });
  };

  getUserStemList = (params = {}) => {
    const { searchText,searchType } = this.state;
    let pageNum = params.pageNum || 1;

    httpGet(httpUrl.getUserStemList, [10, pageNum, false, searchText,searchType], {})
      .then((res) => {
        const pagination = { ...this.state.pagination };
        pagination.current = res.data.currentPage;
        pagination.total = res.data.totalCount;
        this.setState({
          userList: res.data.userStemList,
          pagination
        });
      })
      .catch((error) => {});
  };

  componentDidMount() {
    // console.log(`type: ${this.props.type}, \n userIdx: ${this.props.userIdx}`);
    this.getUserStemList();
  }

  render() {
    const { type, visible, onCancel } = this.props;
    const { franchise, selectedStemUser, userList, searchType } = this.state;
  
    const columns = [
      {
        title: "",
        dataIndex: "idx",
        key: "idx",
        width: 80,
        className: "support-column-number fs-15 lh-21",
        render: (data) => <div>{numberFormat(data)}</div>
      },
      {
          title: "아이디",
          dataIndex: "id",
          key: "id",
          width:220,
          className: "support-column-number fs-15 lh-21",
          render: (data,row) => (
            <div align="left">{data}</div>

          )
      },
      {
        title: "이름",
        dataIndex: "name",
        key: "name",
        className: "support-column-number fs-15 lh-21",
        render: (data,row) => (
          <div>{data}<div>{row.recommendCode}</div></div>
        )
      },
      {
        title:"후원인",
        dataIndex: "parentIdx",
        key:"parentIdx",
        className: "support-column-number fs-15 lh-21",
        render : (data, row) => {
         if(row.userName !== null) return (<div>{row.userName}<div>{row.userRecommendCode}</div></div>);
         if(row.userName === null) return ('-');
        }
      
        
      },
      {
        title: "",
        width: 80,
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => (
          <Button
            onClick={() => {
              this.props.onOk(row);
              this.props.onCancel();
              // this.onChangeTag(row);
            }}>
            선택
          </Button>
        )
      }
    ];

    return (
      <Modal
        visible={visible}
        title={"회원 정보"}
        onCancel={onCancel}
        style={{ minWidth: "800px" }}
        footer={false}>
        {selectedStemUser.idx !== undefined && (
          <Tag key={selectedStemUser.idx}>
            {selectedStemUser.id} /{" "}
            {selectedStemUser.name === null || selectedStemUser.name === ""
              ? "-"
              : selectedStemUser.name}
          </Tag>
        )}
        <div className="flex-row flex-center flex-end m-b-10">
        <SelectBox
            value={string.userListTypeString[searchType]}
            code={string.userListTypeCode}
            codeString={string.userListTypeString}
            onChange={(value) => {
              if (value !== searchType) {
                this.searchTypeHandleChange(value);
              }
            }}
            style={{ width: "100px", marginLeft: "10px" }}
          />
          <Search
            placeholder={
              "아이디/ 이름을 입력해주세요."
            }
            enterButton="검색"
            allowClear
            onSearch={this.onSearch}
            style={{ width: 400 }}
          />
        </div>
        <Table
          id="member-log-table"
          rowKey={(record) => record.idx}
          columns={columns}
          dataSource={userList}
          style={{ marginBottom: "10px" }}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </Modal>
    );
  }
}
export default UserList2;
